import { atom } from "recoil";

export const bookmarkRepo = atom({
  key: "bookmarkRepo",
  default: [],
});
